import script from "./LoginDialog.vue?vue&type=script&setup=true&lang=ts"
export * from "./LoginDialog.vue?vue&type=script&setup=true&lang=ts"

import "./LoginDialog.vue?vue&type=style&index=0&id=3cf870b1&lang=scss&scoped=true"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-3cf870b1"]])

export default __exports__